export default __webpack_public_path__ + "67b88be4e520f8d0441f5bb59ba36411.jpg";